/* eslint-disable */
import { gsap } from 'gsap';
import lottie from 'lottie-web';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import breakpoints from '../lib/breakpoints';

gsap.registerPlugin(ScrollTrigger);

/**
 * Poor man's clamp
 *
 * @link https://www.ajaybadgujar.com/clamping-value-using-math-library-javascript/
 * @param val Value
 * @param min Minimum acceptable value
 * @param max Maximum acceptable value
 */
function clamp(val, min, max) {
  return Math.min(Math.max(min, val), max);
}

/**
 * Platform Animation module. Responsible for the scrolly video on the platform
 * page
 *
 * @param {HTMLElement} el
 * @constructor
 */
function PlatformAnimationNew(el) {
  let animation = null;
  let lottieWrapperId = '#ocpScrollTrigger';

  // function LottieScrollTrigger(vars) {
  //   let playhead = {frame: parseInt(vars.startFrame) || 0};
  //   let target = gsap.utils.toArray(vars.target)[0];
  //   let speeds = {slow: "+=8000", medium: "+=1000", fast: "+=500"};
  //   let scrollTriggerConfig = {
  //     trigger: target,
  //     pin: true,
  //     start: "center center",
  //     end: speeds[vars.speed] || "+=1000",
  //     scrub: 1
  //   };
  //   let animation = lottie.loadAnimation({
  //     container: target,
  //     renderer: vars.renderer || "svg",
  //     loop: false,
  //     autoplay: false,
  //     path: vars.path
  //   });
  //   for (let p in vars) { // let users override the ScrollTrigger defaults
  //     scrollTriggerConfig[p] = vars[p];
  //   }
  //   animation.addEventListener("DOMLoaded", function() {
  //     gsap.to(playhead, {
  //       duration: vars.duration || 0.5,
  //       delay: vars.delay || 0,
  //       frame: parseInt(vars.endFrame) || animation.totalFrames - 1,
  //       ease: vars.ease || "none",
  //       onUpdate: () => {
  //         console.log(playhead.frame)
  //         animation.goToAndStop(playhead.frame, true)
  //       },
  //       scrollTrigger: scrollTriggerConfig
  //     });
  //     // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
  //     ScrollTrigger.sort();
  //     ScrollTrigger.refresh();
  //   });
  //   return animation;
  // }

  // LottieScrollTrigger({
  //   target: "#ocpScrollTrigger",
  //   path: '/animations/ocpLottie.json',
  //   speed: "slow",
  //   scrub: 2 // seconds it takes for the playhead to "catch up"
  //   // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See https://greensock.com/docs/v3/Plugins/ScrollTrigger
  //  });

  function getAnimation(){
    return lottie.loadAnimation({
      container: document.querySelector(lottieWrapperId),
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: '/animations/ocpLottie.json',
      rendererSettings: {
        className: "lottie-svg--ocp",
      }
    });
  }

  function LottieAnimationStop(el, index = 0, total = 0){
    // start and end frames derived from CMS values.
    const startFrame = el.dataset.lottieFrameStart || 0;
    const endFrame = el.dataset.lottieFrameEnd || 0;
    let playhead = {frame: parseFloat(startFrame) || 0};
    let scrollTriggerConfig = {
      trigger: el,
      pin: false,
      // markers: true,
      scrub: true,
      start: "top center",
      end: "bottom center"
    };

    if(index === 0){
      scrollTriggerConfig.start = "25% center";

      // fade the lottie animation in whole scrolling through first "phrase" block
      gsap.to(lottieWrapperId, {
        duration: 0.5,
        delay: 0,
        opacity: 1,
        startAt: {opacity: 0},
        scrollTrigger: {
          trigger: el,
          pin: false,
          // markers: true,
          scrub: true,
          start: "5% center",
          end: "45% center"
        }
      })
    }

    // end the last scroll animation and stop ScrollTrigger pinning when the final 'phrase' reaches center viewport
    if(index === total - 1){
      scrollTriggerConfig.end = "center center";
    }

    gsap.to(playhead, {
      duration: 0.5,
      delay: 0,
      frame: parseFloat(endFrame) || animation.totalFrames - 1,
      ease: "power1",
      onUpdate: () => {
        // console.log(playhead.frame)
        animation.goToAndStop(playhead.frame, true)
      },
      scrollTrigger: scrollTriggerConfig
    });

    // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
    ScrollTrigger.sort();
    ScrollTrigger.refresh();
  }



  /**
   * Kick things off
   */
  function init() {
    animation = getAnimation();
    animation.addEventListener("DOMLoaded", function() {
      const animationStops = gsap.utils.toArray('[data-phrase-new]');
      // console.log(animationStops[animationStops.length - 1])
      gsap.to(lottieWrapperId, {
        duration: 0.5,
        delay: 0,
        frame: animation.totalFrames - 1,
        ease: "none",
        scrollTrigger: {
          trigger: document.querySelector(lottieWrapperId),
          pin: true,
          start: "center center",
          end: "75% center",
          endTrigger: animationStops[animationStops.length - 1],
          scrub: 1,
        }
      })
      animationStops.forEach((animationStop, index, array) => {
        LottieAnimationStop(animationStop, index, array.length);
      })
    });
  }

  ScrollTrigger.matchMedia({
    [`(min-width: ${breakpoints.lg})`]: init,
  });

}

export default PlatformAnimationNew;
